module.exports = __webpack_public_path__ + "static/media/info_panel.dfc703bf.svg";